'use client';

import { PrismicRichText } from '@prismicio/react';
import React from 'react';
import { RichTextField } from '@prismicio/client';
import { FiPlus } from 'react-icons/fi';
import { motion } from 'framer-motion';

export default function FaqAccordion({
  question,
  answer,
}: {
  question: string;
  answer: RichTextField;
}) {
  const [open, setOpen] = React.useState(false);
  return (
    <div
      className="rounded-xl border border-slate-200 bg-white px-4 transition-colors"
    >
      <button
        onClick={() => setOpen((pv) => !pv)}
        className="flex w-full items-center justify-between gap-4 py-4 text-left"
        aria-expanded={open}
      >
        <span className="text-base font-medium text-black">
          {question || 'No question provided'}
        </span>
        <motion.span
          className="pointer-events-none"
          animate={{ rotate: open ? 45 : 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        >
          <FiPlus
            className={`pointer-events-none text-2xl transition-colors ${open ? 'text-blue-900' : 'text-blue-700'}`}
          />
        </motion.span>
      </button>
      {open && (
        <div className="pb-4 text-slate-700 [&_p]:mb-4 [&_p:last-child]:mb-0 [&_a]:text-blue-700 [&_a]:underline [&_a:hover]:text-blue-900 [&_strong]:text-slate-900 [&_ul]:my-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:mb-1">
          <PrismicRichText field={answer} />
        </div>
      )}
    </div>
  );
}
